import "./HomePage.css";
import Narvar from "./Narvar";
import Carousel from "./carousel/Carousel";
import Footer from "./Footer";
import Background from "./spheres/Background";
import LanguageSwitcher from "./LanguageSwitcher";

function HomePage() {
  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      <Background />
      
      <div className="relative z-10 min-h-screen flex flex-col bg-transparent">
        <header className="relative z-20">
          <nav>
            <Narvar />
          </nav>
        </header>

        <main className="flex-1 relative z-10">
          <section className="home-page">
            <Carousel />
          </section>
        </main>

        <footer className="relative z-20">
          <LanguageSwitcher />
          <Footer />
        </footer>
      </div>
    </div>
  );
}

export default HomePage;
